import React from 'react'
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import PrivateLayoutRoute from 'components/Layout/PrivateLayoutRoute';
import { RCPAsegurado } from 'containers/RCP/RCPAsegurado';
import { RCPContratante } from 'containers/RCP/RCPContratante';
import { RCPDatosAsegurado } from 'containers/RCP/RCPDatosAsegurado';
import RCPFinPago from 'containers/RCP/RCPFinPago';
import RCPPago from 'containers/RCP/RCPPago';
import RCPPlanes from 'containers/RCP/RCPPlanes';
import { RCPPreguntas } from 'containers/RCP/RCPPreguntas';
import { RCPResumen } from 'containers/RCP/RCPResumen';
import { RCPVigencia } from 'containers/RCP/RCPVigencia';
import RecuperarCotizacionRCP from 'containers/RCP/RecuperarCotizacionRCP';
import { RCP } from 'containers/RCP/constantes/general';

const RCP_ROUTES = [
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.datosAsegurado}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPDatosAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.preguntas}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPPreguntas}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.planes}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPPlanes}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.resumen}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPResumen}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.cliente}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPContratante}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.asegurado}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.vigencia}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPVigencia}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.pago}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPPago}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${RCP.urls.finPago}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RCPFinPago}
    navBarTab="personas"
  />,
  <PrivateLayoutRoute
    exact={true}
    path="/recuperar-cotizacion-rcp"
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RecuperarCotizacionRCP}
  />,
];

export default RCP_ROUTES;
